import { render, staticRenderFns } from "./ModalEditRule.vue?vue&type=template&id=115ef028"
import script from "./ModalEditRule.vue?vue&type=script&lang=js"
export * from "./ModalEditRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports